module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-green-af653113bdd16b8b25c21e6110ee0aae.svg";